import {Controller} from "stimulus"
import flatpickr from "flatpickr"
import {French} from "flatpickr/dist/l10n/fr.js"
import {Dutch} from "flatpickr/dist/l10n/nl.js"
import moment from 'moment'

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "flatpickr",
        "calendar",
        "fromStr",
        "toStr",
        "calendarToggle",
        "fromMonthStr",
        "fromDayStr",
        "toMonthStr",
        "toDayStr",
    ]

    async initialize() {

        console.log("suis là bro")

        this.flatpickr = undefined

        this.monthStored = []

        this.monthStored.push(moment(new Date()).format("MM/Y"))

        this.days = await this.fetchSeason()

        const lang = document.querySelector("html").dataset.lang
        this.lang = lang ? lang : "fr"

        moment.locale(this.lang)

        // Reset input to prevent browser'back to do shitty things
        this.flatpickrTarget.value = ""

        this.flatpickrLocals = {
            "fr": French,
            "en": undefined,
            "nl": Dutch,
        }

        console.log("this.flatpickrLocals[this.lang]", this.flatpickrLocals[this.lang])
        console.log("this.lang", this.lang)

        this.options = {
            inline: true,
            locale: this.flatpickrLocals[this.lang] ? this.flatpickrLocals[this.lang] : undefined,
            mode: "range",
            dateFormat: "d/m/Y",
            enable: [date => this.enable(date)],
            onDayCreate: (dObj, dStr, fp, dayElem) => this.onDayCreate(dObj, dStr, fp, dayElem),
            onMonthChange: async (selectedDates, dateStr, instance) => this.onMonthChange(selectedDates, dateStr, instance),
            onChange: (selectedDates, dateStr, instance) => this.onChange(selectedDates, dateStr, instance),
        }

        this.createNewFlatpickr()

        if ( this.hasCalendarToggleTarget ) {
            this.calendarToggleTarget.addEventListener("click", () => {
                this.flatpickr.toggle()
            })
        }

        //remove button view rooms
        //window.addEventListener('scroll', ()=>{
        //    const positionCalendar = 2000//position block + sa hauteur
        //    if(scrollY >= positionCalendar){
        //        this.buttonTarget.classList.remove('is-active')
        //    }
        //})

    }

    onChange(selectedDates, dateStr, instance) {
        let firstDate = selectedDates[0]
        let lastDate = selectedDates.length > 1 ? selectedDates[selectedDates.length - 1] : false
        let firstDateStr = moment(firstDate).format("DD/MM/Y")
        let firstDateMonthStr = moment(firstDate).format("MMMM")
        let firstDateDayStr = moment(firstDate).format("DD")
        let lastDateStr = lastDate ? moment(lastDate).format("DD/MM/Y") : ""
        let lastDateMonthStr = moment(lastDate).format("MMMM")
        let lastDateDayStr = moment(lastDate).format("DD")

        this.fromStrTargets.forEach(item => item.innerHTML = firstDateStr)

        if ( this.hasFromMonthStrTarget ) {
            this.fromMonthStrTarget.innerHTML = firstDateMonthStr
            this.fromDayStrTarget.innerHTML = firstDateDayStr
        }

        if (lastDate) {
            this.toStrTargets.forEach(item => item.innerHTML = lastDateStr)
            if ( this.hasFromMonthStrTarget ) {
                this.toMonthStrTarget.innerHTML = lastDateMonthStr
                this.toDayStrTarget.innerHTML = lastDateDayStr
            }
        } else {
            this.toStrTargets.forEach(item => item.innerHTML = "...")
            if ( this.hasFromMonthStrTarget ) {
                this.fromMonthStrTarget.innerHTML = "..."
                this.fromDayStrTarget.innerHTML = "..."
            }
        }

        // Can't select the same day
        if (selectedDates.length === 2 && firstDateStr === lastDateStr) {
            this.flatpickr.setDate([], false)
            this.flatpickr.jumpToDate(firstDate, false)
            this.toStrTargets.forEach(item => item.innerHTML = "...")
            this.fromStrTargets.forEach(item => item.innerHTML = "...")
            this.toMonthStrTarget.innerHTML = "..."
            this.toDayStrTarget.innerHTML = "..."
            this.fromMonthStrTarget.innerHTML = "..."
            this.fromDayStrTarget.innerHTML = "..."
        }

        //button view rooms
        //this.buttonTarget.classList.add('is-active')
    }

    enable(date) {
        const yesterday = moment(new Date()).subtract(1, "days")
        const loopDate = moment(date)
        const loopDateStr = loopDate.format("DD/MM/Y")
        const dayInArray = this.days.find(day => day.date === loopDateStr)
        const isNotClosed = !dayInArray || dayInArray && dayInArray.status.toLowerCase() !== "fermé"
        const isNotPassed = loopDate.isAfter(yesterday, 'day')
        return isNotClosed && isNotPassed
    }

    onDayCreate(dObj, dStr, fp, dayElem) {
        const loopDate = moment(dayElem.dateObj)
        const loopDateStr = loopDate.format("DD/MM/Y")
        const dayInArray = this.days.find(day => day.date === loopDateStr)
        dayElem.innerHTML = `<span>${dayElem.innerHTML}</span>`
        dayElem.classList.add("is-normal")
        if (dayInArray) {
            if (dayInArray.status.toLowerCase() === "haute saison") {
                dayElem.classList.add("is-hight-season")
                dayElem.classList.remove("is-normal")
            } else {
                dayElem.classList.add("is-low-season")
                dayElem.classList.remove("is-normal")
            }
        }
    }

    async onMonthChange(selectedDates, dateStr, instance) {
        this.calendarTarget.classList.add("is-loading")
        const monthNumber = `${instance.currentMonth + 1}`
        const month = `${monthNumber.length > 1 ? `${monthNumber}` : `0${monthNumber}`}/${instance.currentYear}`
        const newViewedDate = `01/${month}`
        if (!this.monthStored.find(loopMonth => loopMonth === month)) {
            // Fetch season
            const newDays = await this.fetchSeason(month)
            this.monthStored.push(month)
            this.days.push(...newDays)
        }
        // Store previously selected dates
        const previouslySelectedDates = this.flatpickr.selectedDates
        // Destroy and rebuild flatpickr instance to reload the events
        this.flatpickr.destroy()
        this.createNewFlatpickr()
        // Set previously selected dates and jump to the new month
        this.flatpickr.setDate(previouslySelectedDates, false)
        this.flatpickr.jumpToDate(newViewedDate, false)
        this.calendarTarget.classList.remove("is-loading")
    }

    createNewFlatpickr() {
        this.flatpickr = new flatpickr(this.flatpickrTarget, this.options)
    }

    async fetchSeason(month) {

        let apiUrl = `${window.urls.api}app/get-month-season`
        apiUrl += `${month ? `?month=${month}` : ``}`

        const response = await fetch(apiUrl)
        const json = await response.json()

        if (response.status === 200) {
            return json.results
        } else {
            console.error("Error fetch seasons", response)
            return response
        }

    }

}
